import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
function TimelineStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6,
    titleColor1 = _getThemeData.titleColor1;
  var _getThemeData2 = getThemeData(props, 'timeline'),
    fontSize = _getThemeData2.fontSize,
    lineHeight = _getThemeData2.lineHeight;
  return css([".c7n-timeline.c7n-timeline{.c7n-timeline-item{cursor:pointer;&:hover{.c7n-timeline-item-head{border-color:", " !important;}.c7n-timeline-item-content{color:", ";}}.c7n-timeline-item-content{color:", ";font-size:", "px;line-height:", "px;}.c7n-timeline-item-head-blue{color:", ";border-color:", ";}}.c7n-timeline-item-last .c7n-timeline-item-content{min-height:", "px;}}"], primary6, primary6, titleColor1, fontSize, lineHeight, primary6, primary6, lineHeight);
}
export default TimelineStyle;